var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.92599V16.074C5 19.8514 8.90708 22.2516 12.0498 20.3209L18.6813 16.247C21.7729 14.3478 21.7728 9.65216 18.6813 7.75294L12.0497 3.67896C8.90707 1.74832 5 4.14854 5 7.92599ZM11.0029 5.38308L17.6345 9.45706C19.4552 10.5756 19.4552 13.4244 17.6344 14.5429L11.0029 18.6168C9.23328 19.7039 7 18.332 7 16.074V7.92599C7 5.66795 9.23328 4.29598 11.0029 5.38308Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadVideo);
export default __webpack_public_path__ + "static/media/upload_video.91228ca4048e06b410a12565d8a3c2fe.svg";
export { ForwardRef as ReactComponent };